const extractClickData = (payload, application) => {
  const { click_position, click_text, click_url } = payload;
  if (click_position || click_text || click_url) {
    return {
      ...click_position && { click_position },
      ...click_text && {
        click_id: `${application} | ${click_text}`,
        click_text
      },
      ...click_url && { click_url }
    };
  } else {
    return void 0;
  }
};
export {
  extractClickData
};
